import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';

var PlusSignIcon = function (_a) {
    var className = _a.className;
    return (jsx("svg", __assign({ className: className, width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.94434 10.9375V17.5H11.8193V10.9375H18.3818V9.0625H11.8193V2.5H9.94434V9.0625H3.38184V10.9375H9.94434Z", fill: "currentColor" }) })));
};

export { PlusSignIcon };
